import { ResponseResult } from '~/static/types/base'
import { useNuxtApp } from '#app'

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
}

export const useApi = async <R = unknown, E = object> (
  path: string,
  queryParams: object = {},
  method: HttpMethod = HttpMethod.GET,
  body: object | null = null,
): Promise<ResponseResult<R, E>> => {
  return useNuxtApp().$useApi<R, E>(path, queryParams, method, body)
}
